module.exports = __webpack_public_path__ + "img/hoverLayer.29c8fc85.svg";